import React from 'react';

interface SuccessModalProps {
    isOpen: boolean;
    productName: string;
    onClose: () => void;
}

const WHATSAPP_NUMBER = '5575992451237';

const SuccessModal: React.FC<SuccessModalProps> = ({ isOpen, productName, onClose }) => {
    if (!isOpen) return null;

    const message = encodeURIComponent(
        `Olá, Elza! Acabei de selecionar o presente "${productName}" na lista da casa nova do Ivo. Quero combinar a entrega.`
    );
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[60] p-4 animate-fade-in">
            <div className="bg-gradient-card rounded-2xl shadow-soft-lg max-w-lg w-full p-8 border border-white/50 transform transition-all animate-scale-in max-h-[90vh] overflow-y-auto">
                <div>
                    <div className="mb-6 text-center">
                        <div className="w-20 h-20 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center mx-auto mb-4 animate-scale-in">
                            <svg
                                className="w-12 h-12 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={3}
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <h2 className="text-3xl font-bold text-text-primary mb-3">
                            Obrigado! 🎉
                        </h2>
                        <p className="text-lg text-text-secondary leading-relaxed">
                            Produto <span className="font-semibold text-primary-700">{productName}</span> foi selecionado com sucesso!
                        </p>
                    </div>

                    <div className="text-left space-y-4 text-text-secondary mb-6">
                        <h3 className="text-lg font-bold text-text-primary">
                            🎁 Orientações para entrega
                        </h3>
                        <p className="leading-relaxed">
                            Para que o Ivola não descubra a surpresa antes da hora, pedimos que os presentes não sejam entregues ou enviados diretamente para ele. 💛
                        </p>
                        <ul className="space-y-3 list-disc pl-5 leading-relaxed">
                            <li>
                                <strong className="text-text-primary">Compras presenciais:</strong> o presente poderá ser entregue a{' '}
                                <strong className="text-text-primary">Elza Barbosa ou Miriane Fiuza</strong>, no endereço{' '}
                                <strong className="text-text-primary">Rua Antonio Silveira França, 272, Assembleia – 44380-000 - Cruz das Almas/BA</strong>.
                            </li>
                            <li>
                                <strong className="text-text-primary">Compras pela internet:</strong> utilize como endereço de entrega{' '}
                                <strong className="text-text-primary">Rua Antonio Silveira França, 272, Assembleia – 44380-000 - Cruz das Almas/BA</strong>, em nome de{' '}
                                <strong className="text-text-primary">Ivo Conceição Barboza</strong>.
                            </li>
                            <li>
                                <strong className="text-text-primary">Prazo para entrega:</strong> se possível, pedimos que os presentes sejam entregues até{' '}
                                <strong className="text-text-primary">30/09/2026</strong>, para que possamos organizar tudo antes da surpresa.
                            </li>
                            <li>
                                <strong className="text-text-primary">Dúvidas ou necessidade de combinar a entrega:</strong> fale com{' '}
                                <strong className="text-text-primary">Elza Barbosa</strong>, pelo{' '}
                                <strong className="text-text-primary">WhatsApp 75 9 9245-1237</strong>.
                            </li>
                        </ul>
                        <p className="leading-relaxed text-center font-medium text-text-primary pt-2">
                            E não se esqueça: é segredo! 🤫🏡💛
                        </p>
                    </div>

                    <a
                        href={whatsappUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full px-4 py-2.5 mb-4 bg-[#25D366] hover:bg-[#1EBE5A] text-white rounded-lg transition-all font-medium flex items-center justify-center gap-2"
                    >
                        <svg
                            className="w-5 h-5"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                        </svg>
                        Falar no WhatsApp com Elza
                    </a>

                    <button
                        onClick={onClose}
                        className="w-full px-6 py-3 bg-gradient-to-r from-primary-600 to-primary-700 text-white rounded-xl hover:from-primary-700 hover:to-primary-800 transition-all font-semibold shadow-lg shadow-primary-300 hover:shadow-primary-400 transform hover:scale-105"
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessModal;
